{
  "title": "Life Transference",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "3rd-level necromancy",
  "level": 3,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "You sacrifice some of your health to mend another creature’s injuries. You take 4d8 necrotic damage, which can’t be reduced in any way, and one creature of your choice that you can see within range regains a number of hit points equal to twice the necrotic damage you take.",
    "At Higher Levels: When you cast this spell using a spell slot of 4th level or higher, the damage increases by 1d8 for each slot level above 3rd.",
    "Spell Lists: Cleric, Wizard"
  ],
  "spellLists": ["cleric", "wizard"]
}
